<template>
  <div class="guarantor-new wrapper">
    <div class="steps-wrap">
      <!-- 大屏幕：左右布局，垂直steps -->
      <div class="steps-vertical">
        <Steps :current="currentStep" direction="vertical" size="small">
          <Step title="项目信息" content="选择/填写项目信息"></Step>
          <Step title="保函信息" content="填写保函信息"></Step>
          <Step title="附件上传" content="上传担保合同及附件"></Step>
          <Step title="提交" content="确认并提交"></Step>
        </Steps>
      </div>
      <!-- 小屏幕：上下布局，水平steps -->
      <div class="steps-horizontal">
        <Steps :current="currentStep" direction="horizontal" size="small">
          <Step title="项目信息" content="选择/填写项目信息"></Step>
          <Step title="保函信息" content="填写保函信息"></Step>
          <Step title="附件上传" content="上传担保合同及附件"></Step>
          <Step title="提交" content="确认并提交"></Step>
        </Steps>
      </div>
    </div>
    <div class="views">
      <router-view
        :data="guaranteeModel"
        :key="currentStep"
        :projectRegisterEnabled="projectRegisterEnabled"
        :correctionMode="correctionMode"
        @go-backward="goBackward"
        @finish-step1="finishStep1"
        @finish-step2="finishStep2"
        @finish-step3="finishStep3"
        @finish-step4="finishStep4"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'guarantor-new-puyang',
  props: {
  },
  data () {
    return {
      projectRegisterEnabled: false,
      currentStep: 0,
      correctionMode: false,
      guaranteeModel: {
        // Pre-filled from user permissions
        cityId: null,
        cities: [],
        industryId: null,
        industryName: null,
        // Project info
        project: null,
        owner: null,
        contractor: null,
        supervisory: null,
        // Guarantee info
        beneficiary: null,
        amount: null,
        fee: null,
        variety: null,
        gMethod: 0,
        gStartDate: null,
        gEndDate: null,
        gFeeRate: null,
        opName: null,
        opContactTel: null,
        jointGuarantors: []
      }
    }
  },
  watch: {
  },
  mounted () {
    let pathSegs = this.$route.path.split('/')
    let step = pathSegs[pathSegs.length - 1]
    if (step.toLowerCase().indexOf('step') === 0) {
      this.currentStep = parseInt(step.substr(4)) - 1
    }
    // Pre-fill from user's permitted cities and industries
    this.prefillFromUserProfile()
    if (this.$route.params.orderNumber) {
      this.getGuaranteeDetail()
      this.checkCorrectionMode()
    }
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    prefillFromUserProfile () {
      // Get user's city and industry from userInfo and guarantorInfo
      let userInfo = this.$store.getters.userInfo
      // let guarantorInfo = this.$store.getters.guarantorInfo

      if (userInfo && userInfo.cityId) {
        this.guaranteeModel.cityId = userInfo.cityId
      }
      // Industry will be pre-filled in step1 after loading permitted industries
    },
    async checkCityEnableProjectRegister (cityId, industryId) {
      let res = await this.$Api.KVS.getKVS('PROJECT_REGISTER_ENABLED_CITIES').catch(() => {
        return Promise.resolve(false)
      })
      if (!res) {
        return Promise.resolve(false)
      }
      let cities = res.split(',')
      if (cities.indexOf(cityId.toString()) < 0) {
        return Promise.resolve(false)
      }
      res = await this.$Api.KVS.getKVS('PROJECT_REGISTER_ENABLED_INDUSTRIES').catch(() => {
        return Promise.resolve(false)
      })
      if (!res) {
        return Promise.resolve(false)
      }
      let industries = res.split(',')
      if (industries.indexOf(industryId.toString()) < 0) {
        return Promise.resolve(false)
      }
      return Promise.resolve(true)
    },
    getGuaranteeDetail () {
      this.$Api.Guarantee.getGuaranteeDetail(this.$route.params.orderNumber)
      .then(async (res) => {
        let copyData = JSON.parse(JSON.stringify(res))
        Object.assign(this.guaranteeModel, copyData)
        this.projectRegisterEnabled = await this.checkCityEnableProjectRegister(this.guaranteeModel.cityId, this.guaranteeModel.industryId)
        this.currentStep = 1
        this.$router.replace({path: '/guarantees/new-puyang/step2'})
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    async checkCorrectionMode () {
      try {
        let corrections = await this.$Api.Guarantee.getCorrections(this.$route.params.orderNumber)
        if (corrections && corrections instanceof Array && corrections.length > 0) {
          // status=0 待整改, status=2 未通过 - 都进入整改模式
          let pendingCorrection = corrections.find(c => c.status === 0 || c.status === 2)
          if (pendingCorrection) {
            this.correctionMode = true
            this.currentStep = 2
            this.$router.replace({path: '/guarantees/new-puyang/step3'})
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    goBackward () {
      this.currentStep -= 1
      this.$router.push({path: '/guarantees/new-puyang/step' + (this.currentStep + 1)})
    },
    finishStep1 (model) {
      console.log('finish step1', model)
      Object.assign(this.guaranteeModel, model)
      this.currentStep = 1
      this.$router.replace({path: '/guarantees/new-puyang/step2'})
    },
    finishStep2 (model) {
      console.log('finish step2', model)
      Object.assign(this.guaranteeModel, model)
      this.currentStep = 2
      this.$router.replace({path: '/guarantees/new-puyang/step3'})
    },
    finishStep3 (model) {
      console.log('finish step3', model)
      Object.assign(this.guaranteeModel, model)
      this.currentStep = 3
      this.$router.replace({path: '/guarantees/new-puyang/step4'})
    },
    finishStep4 (model) {
      console.log('finish step4', model)
      this.$router.push({path: '/guarantees/list'})
    }
  }
}
</script>

<style lang="less" scoped>
.guarantor-new.wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  align-items: stretch;
  height: 100%;
  .steps-wrap {
    flex-shrink: 0;
    padding: 16px 24px;
    background: #fafafa;
    border-bottom: 1px solid #e8e8e8;
    .steps-vertical {
      display: none;
    }
    .steps-horizontal {
      display: block;
    }
  }
  .views {
    flex: 1;
    overflow: hidden;
  }
}
@media (min-width: 768px) {
  .guarantor-new.wrapper {
    flex-direction: row;
    .steps-wrap {
      width: 180px;
      padding: 24px 16px;
      border-bottom: none;
      border-right: 1px solid #e8e8e8;
      .steps-vertical {
        display: block;
      }
      .steps-horizontal {
        display: none;
      }
    }
    .views {
      flex: 1;
    }
  }
}
</style>